export const BASE_URL = 'https://final-task-backend.railway.internal';
// export const sessionLifetime = 86400000; // 24h
export const sessionLifetime = 1800000; // 30min
// export const sessionCheckInterval = 300000; // 5min
export const sessionCheckInterval = 60000; // 1min
